import personInfoModal from "./index";
import Vue from "vue";

export default function (data) {
  const div = document.createElement("div");
  const el = document.createElement("div");
  div.id = "person-info-modal";
  div.appendChild(el);
  document.body.appendChild(div);

  let instance = null;
  function render() {
    instance = new Vue({
      el,
      components: { personInfoModal },
      data() {
        return {
          isShow: false,
          className: "",
        };
      },
      methods: {
        // 打开弹框
        open() {
          this.className = "open";
        },
        //  关闭信息弹框
        on_close_modal() {
          this.isShow = false;
          this.className = "";
        },
        on_destroy() {
          instance = null;
          div.parentNode.removeChild(div);
          document.body.classList.remove("disabled-scroll");
        },
      },
      created() {
        this.$nextTick(() => {
          this.isShow = true;
        });
      },

      render() {
        return (
          <transition
            name="fade"
            vOn:after-leave={this.on_destroy}
            vOn:after-enter={this.open}
          >
            {this.isShow ? (
              <personInfoModal
                data={data}
                vOn:onClose={this.on_close_modal}
                class={this.className}
              />
            ) : null}
          </transition>
        );
      },
    });
  }

  render();
}
